import React, { useState } from "react";

interface IdentificationPageProps {
  onSubmit: (voter: { firstname: string; lastname: string, hasVoted: boolean }) => void;
}

const IdentificationPage: React.FC<IdentificationPageProps> = ({ onSubmit }) => {
	const [firstname, setFirstname] = useState("");
	const [lastname, setLastname] = useState("");

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		if (firstname && lastname) {
			fetch(`${process.env.REACT_APP_BACKEND_URL}/api/voter/`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ firstname, lastname }),
			})
			.then((response) => {
				if (!response.ok) {
					throw new Error("Network response was not ok");
				}
				return response.json();
			})
			.then((data) => {
				console.log(data)
				console.log("Voter registered:", data);
				onSubmit({ firstname, lastname, hasVoted: data.data.hasVoted });
			})
			.catch((error) => {
				console.error("There was a problem with the fetch operation:", error);
			});
		}
		};

	return (
	<div className="identification-page">
		<h2>Entrez vos informations</h2>
		<form onSubmit={handleSubmit}>
		<input
			type="text"
			placeholder="Prénom"
			value={firstname}
			onChange={(e) => setFirstname(e.target.value)}
			required
		/>
		<input
			type="text"
			placeholder="Nom"
			value={lastname}
			onChange={(e) => setLastname(e.target.value)}
			required
		/>
		<button type="submit">Continuer</button>
		</form>
	</div>
	);
};

export default IdentificationPage;
